import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {
  transform(value: string): string {
    console.log(value);
    if (!value) return value;

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return value.replace(urlRegex, (url) => {
      return `<a href="${url}" class="text-muted text-lowercase" target="_blank">${url}</a>`;
    });
  }
}
